module.exports = __webpack_public_path__ + "static/media/boundcloud-vector.d0afb1ad.svg";